import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import Topnav from "../common/Topnav";
import Footer from "../common/Footer";
import bannerImage from "../../Images/commonimg/blog1.jpg";
import NotFoundPage from "../../404Page";

const BlogDetails = () => {
  const { url } = useParams();
  const [blog, setBlog] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  // Base URL for blog images if they are relative paths
  const baseUrl = "https://isbmalumni.com/admin-assets/blogs/";

  useEffect(() => {
    // Only fetch if blogId exists
    if (!url) {
      setError("Invalid blog ID.");
      setLoading(false);
      return;
    }

    console.log("Fetching blog with ID:", url); // Debug

    const fetchBlog = async () => {
      try {
        // Make sure to remove any leading colon (:) and convert to number
        const response = await axios.get(
          `https://isbmalumni.com/fourms-id.php?id=${url}`,
        );

        console.log("API response:", response.data); // Debug

        const { success, data, error: apiError } = response.data;

        if (success && data) {
          setBlog(data); // directly set the single object
        } else {
          setError(apiError || "Blog not found.");
        }
      } catch (err) {
        console.error("Error fetching blog:", err);
        setError("Failed to fetch blog details.");
      } finally {
        setLoading(false);
      }
    };

    fetchBlog();
  }, [url]);

  useEffect(() => {
    if (blog) {
      document.title = blog.meta_title || "Blog Details";

      // Update meta description
      let metaDesc = document.querySelector("meta[name='description']");
      if (!metaDesc) {
        metaDesc = document.createElement("meta");
        metaDesc.setAttribute("name", "description");
        document.head.appendChild(metaDesc);
      }
      metaDesc.setAttribute("content", blog.meta_description || "");

      // Update schema (JSON-LD)
      let schemaTag = document.getElementById("blog-schema");
      if (!schemaTag) {
        schemaTag = document.createElement("script");
        schemaTag.setAttribute("type", "application/ld+json");
        schemaTag.setAttribute("id", "blog-schema");
        document.head.appendChild(schemaTag);
      }
      schemaTag.textContent = blog.schema || "";
    }
  }, [blog]);

  if (loading) return <p className="text-center my-5">Loading...</p>;
  // if (error) return <p className="text-center text-danger my-5">{error}</p>;
  // if (!blog) return <p className="text-center my-5">No blog found.</p>;

  if (!loading && (error || !blog)) {
    return <NotFoundPage />;
  }

  return (
    <>
      <Topnav />

      {/* Banner */}
      <section
        className="section-hero-banner ptb-50"
        style={{
          backgroundImage: `linear-gradient(rgba(28,36,71,0.8), rgba(28,36,71,0.8)), url(${bannerImage})`,
        }}
      >
        <div className="banner-hero-overlay">
          <div className="container-xxl">
            <div className="section-hero-content text-center">
              <h1>{blog?.title || "Blog Details"}</h1>
              <ol className="breadcrumb mt-3 mb-0 justify-content-center">
                <li className="breadcrumb-item">
                  <Link
                    to="/"
                    style={{ color: "#fff", textDecoration: "none" }}
                  >
                    Home
                  </Link>
                </li>
                <li
                  className="breadcrumb-item active text-white"
                  aria-current="page"
                >
                  Blog Details
                </li>
                <hr className="section-divider" />
              </ol>
            </div>
          </div>
        </div>
      </section>

      {/* Blog Content */}
      <section className="container my-5">
        <div className="clearfix">
          {/* Blog Image */}
          <img
            src={
              blog.banner && blog.banner.trim() !== ""
                ? `https://isbmalumni.com/admin/uploads/forums/${blog.banner}`
                : bannerImage
            }
            alt={blog?.title || "Blog Banner"}
            className="img-fluid rounded float-lg-end ms-lg-4 mb-3"
            style={{ maxWidth: "400px" }}
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = bannerImage;
            }}
          />

          {/* Blog Description (HTML content) */}
          <div dangerouslySetInnerHTML={{ __html: blog?.description || "" }} />

          {/* Blog Title & Date */}
          <div className="row">
            <p className="text-muted col-6">
              <i
                className="ti ti-calendar me-1 text-black"
                style={{ fontSize: "20px" }}
              ></i>{" "}
              {/* user/author icon */}
              {blog?.date_created
                ? new Date(blog.date_created).toLocaleDateString("en-GB")
                : "N/A"}
            </p>
            <p className="text-muted col-6 text-end">
              <i
                className="ti ti-user me-1 text-black"
                style={{ fontSize: "20px" }}
              ></i>{" "}
              {/* user/author icon */}
              {blog?.user_id ?? "N/A"}
            </p>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default BlogDetails;
